var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"footer-inner"},[_c('h4',[_vm._v("数字商机港 · 专注B2B电子商务服务")]),_c('p',[_vm._v("汇集海量产品与企业服务数据，为企业提供高效推广")]),_c('a',{staticClass:"note",on:{"click":_vm.goToExternalSite}},[_vm._v("鲁ICP备2022032657号")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }